// app/javascript/channels/chat_channel.js
import consumer from "./consumer"


consumer.subscriptions.create({channel: "PublicChannel"}, {
    connected() {
        console.log("PublicChannel:: connected");
        //  console.log(this);
    },
    received(data) {
        // Create a new event, allow bubbling, and provide any data you want to pass to the "detail" property
        const eventAwesome = new CustomEvent("notification:show", {
            bubbles: true,
            detail: {text: () => data},
        });
        console.log("channel::public", JSON.stringify(data));
    }

})


// app/javascript/channels/appearance_channel.js